import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, message, Tag, Pagination, Alert, Upload, Button, DatePicker, Dropdown, Menu, Select } from 'antd';
import EstadoCuentaService from '../../../services/api/estado_cuentas';
import helper from '../../../utils/helper';
import apiConfig from '../../../services/api/config';
import { EyeOutlined, UploadOutlined } from '@ant-design/icons';

const dateFormat = 'DD/MM/YYYY';

class IndexEstadoCuentas extends Component {
  state = {
    cargando: false,
    estado_cuentas: [],
    de_formato: '',
    hasta_formato: '',
    de: '',
    hasta: '',
    estado: '',
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);

    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarMesaPates();
  }

  handleChangeSearch = (value) => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = value.target.value;
    this.setState({
      page: configPage,
      buscar_texto: value.target.value
    }, () => {
      this.cargarMesaPates();
    });
  }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarMesaPates();
    });
  }

  cargarMesaPates = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    EstadoCuentaService.getEstadoCuentas(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            estado_cuentas: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            estado_cuentas: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarMesaPates();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarMesaPates(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };

  handleBeforeUpload = (file) => {
    const isExcel =
      file.type === 'text/csv' ||
      file.type === 'application/vnd.ms-excel' ||
      file.type === 'application/x-msexcel' ||
      file.type === 'application/x-excel' ||
      file.type === 'application/x-ms-excel' ||
      file.type === 'application/x-dos_ms_excel' ||
      file.type === 'application/xls' ||
      file.type === 'application/x-xls' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (!isExcel) {
      message.error('¡Solo puedes subir archivos Excel!');
    }

    const esValido = isExcel;
    if (esValido) {
      this.setState({
        file,
      }, () => {
        this.handleClickUpload();
      });
    }

    return false;
  };

  handleClickUpload = () => {
    if (this.state.file && Object.entries(this.state.file).length === 1) {
      const hide = message.loading('Confirmando envío...', 0);
      this.setState({ subiendo_archivo: true });
      const data = {
        file: this.state.file,
      };

      EstadoCuentaService.importarCuentaXLS(
        data,
        (success) => {
          setTimeout(hide, 0);
          if (success) {
            this.cargarMesaPates();
            this.setState({ subiendo_archivo: false });
            message.success('Importación con exito.');
          }
        },
        (error) => {
          if (error) {
            setTimeout(hide, 0);
            this.setState({
              subiendo_archivo: false,
            });
            message.error(error.message);
          }
        }
      );
    }
  };

  handleChangeFechaDesde = (e) => {
    this.setState({
      de: e,
      de_formato: e ? e.format('YYYY/MM/DD') : null,
    }, () => {
      this.cargarMesaPates();
    });
  };

  handleChangeFechaHasta = (e) => {
    this.setState({
      hasta: e,
      hasta_formato: e ? e.format('YYYY/MM/DD') : null,
    }, () => {
      this.cargarMesaPates();
    });
  };

  handleExportar = (tipo) => {
    const page = Object.assign({}, this.state.page);
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/cuentas-exportar-xls${path}&authorization=${token}`;
    window.open(url_exportar);
  }

    handleExportarCumple = (tipo) => {
    const page = Object.assign({}, this.state.page);
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/cuentas-cumple-exportar-xls${path}&authorization=${token}`;
    window.open(url_exportar);
  }

  handleChange = (estado) => {
    this.setState({
      estado
    }, () => {
      this.cargarMesaPates();
    });
  };

  render() {
    const columns = [
      {
        title: 'N°',
        dataIndex: 'name',
        key: 'name',
        responsive: ['xl'],
        width: 50,
        render: (text, record, index) => {
          return <div>{index + 1}</div>;
        },
      },
      {
        title: 'RUC/DNI',
        dataIndex: 'numero_documento',
        key: 'numero_documento',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Código Afiliado',
        dataIndex: 'codigo',
        key: 'codigo',
        responsive: ['xl'],
      },
      {
        title: 'Nombres',
        dataIndex: 'razon_social',
        key: 'razon_social',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Correo',
        dataIndex: 'email',
        key: 'email',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },
      {
        title: 'Teléfono',
        dataIndex: 'telefono',
        key: 'telefono',
        responsive: ['md', 'lg', 'xl'],
      },
      {
        title: 'F. Nacimiento',
        dataIndex: 'fecha_nacimiento',
        key: 'fecha_nacimiento',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'F. Colegiatura',
        dataIndex: 'fecha_colegiatura',
        key: 'fecha_colegiatura',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text) => {
          return <Tag color={text === 'BAJA'
          ? 'red'
          : text === 'HABIL'
          ? 'green'
          : text === 'INHABILITADO POR DEUDA'
          ? 'blue'
          : ''}>{text || 'Sin Estado'}</Tag>;
        },
      },
      {
        title: 'Detalle',
        dataIndex: 'estado',
        key: 'estado',
        width: 70,
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {helper.tienePermiso(this.props.permisos, 'Ver detalle estado de cuenta') ? (
                <Link to={`/estado-cuentas/${record.id}/show`}>
                  <EyeOutlined style={{ color: '#1890ff' }} />
                </Link>
              ) : (
                <EyeOutlined style={{ color: '#b5b5b5' }} />
              )}
            </div>
          );
        },
      },
    ];

    const menu = (
      <Menu>
        {/* <Menu.Item key="1" onClick={() => this.handleExportar('pdf')}>
          TXT
        </Menu.Item> */}
        <Menu.Item key="2" onClick={() => this.handleExportar('xls')}>
          Excel
        </Menu.Item>
        <Menu.Item key="2" onClick={() => this.handleExportarCumple('xls')}>
          Excel saludo de cumpleaños
        </Menu.Item>
      </Menu>
    );

    return (
      <div>
        <div className="page-header">
          <h2>Estado de Colegiado</h2>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
            <div>
              {
                this.state.estado_cuentas && this.state.estado_cuentas.length === 0 &&
                <Upload
                  name="file"
                  className="cuenta-uploader"
                  showUploadList={false}
                  action="//ccpll.test/api/archivos"
                  beforeUpload={this.handleBeforeUpload}
                >
                  <Button loading={this.state.subiendo_archivo}>
                    <UploadOutlined /> Importa XLS
                  </Button>
                </Upload>
              }
            </div>
            <div>
              <Select
                placeholder='Seleccione'
                style={{ width: 220 }}
                onChange={this.handleChange}
                options={[
                  {
                    value: 'VITALICIO',
                    label: 'VITALICIO',
                  },
                  {
                    value: 'BAJA DEFINITIVA POR DISOLUCION',
                    label: 'BAJA DEFINITIVA POR DISOLUCION',
                  },
                  {
                    value: 'BAJA TEMPORAL POR VIAJE',
                    label: 'BAJA TEMPORAL POR VIAJE',
                  },
                  {
                    value: 'BAJA DEFINITIVA POR FALLECIMIENTO',
                    label: 'BAJA DEFINITIVA POR FALLECIMIENTO',
                  },
                  {
                    value: 'INHABILITADO POR DEUDA',
                    label: 'INHABILITADO POR DEUDA',
                  },
                  {
                    value: 'BAJA TEMPORAL POR DEUDA',
                    label: 'BAJA TEMPORAL POR DEUDA',
                  },
                  {
                    value: 'HABIL',
                    label: 'HABIL',
                  },
                  {
                    value: 'NUEVO',
                    label: 'NUEVO',
                  },
                  {
                    value: 'BAJA DEFINITIVA POR RENUNCIA',
                    label: 'BAJA DEFINITIVA POR RENUNCIA',
                  },
                ]}
              />
            </div>
            <div>
            Del&nbsp;
              <DatePicker
                value={this.state.de ? Moment(this.state.de, dateFormat) : ''}
                format={dateFormat}
                onChange={(e) => this.handleChangeFechaDesde(e)}
              />
            </div>
            <div>
            Al&nbsp;
              <DatePicker
                value={this.state.hasta ? Moment(this.state.hasta, dateFormat) : ''}
                format={dateFormat}
                onChange={(e) => this.handleChangeFechaHasta(e)}
              />
            </div>
            <div>
              <Dropdown overlay={menu} placement="bottomRight">
                <Button type='primary' loading={this.props.guardando} className="detalle__buttton__margin--left">
                  Exportar como
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver registro estado de cuentas') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de registro gestión colegiatura"
                  type="error"
                />
              ):
                <div className="card__body">
                  <Table
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={this.state.estado_cuentas}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexEstadoCuentas);
